import { Box, Button, Group, Stack, Text, Title, rem } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { ListCOD } from './list-cod';
import { assetPrefix } from '@/lib/constants';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

type ModalContentProps = {
  onClose: () => void;
};

export function ModalMaxCodInfoDetail({ onClose }: ModalContentProps) {
  const isMobile = useIsMobile();
  const tBooking = useTranslations('booking');

  return (
    <Stack gap={rem(16)}>
      <Box
        w="100%"
        h={rem(200)}
        style={{
          backgroundImage: `url(${assetPrefix}/static/images/cod/cod-thumbnail.webp)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',

          borderRadius: rem(8),
        }}
      ></Box>
      <Stack ta="center" gap={rem(12)}>
        <Title order={3}>
          {tBooking('location.modal_learn_about_cod_title')}
        </Title>
        <Text fz={14} fw={500} c="#697077">
          {tBooking('location.modal_learn_about_cod_description')}
        </Text>

        <ListCOD />
      </Stack>
      <Group
        py={rem(16)}
        pos={isMobile ? 'fixed' : 'unset'}
        left={rem(16)}
        right={rem(16)}
        bottom={rem(16)}
      >
        <Button onClick={onClose} fw={700} h={48} fullWidth>
          {tBooking('location.modal_learn_about_cod_btn_got_it')}
        </Button>
      </Group>
    </Stack>
  );
}
